module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-sm-8 m-sm-auto col-md-5 m-md-auto"
  }, [_c('h2', {
    staticClass: "text-center py-3 py-sm-5"
  }, [_vm._v("パスワード再発行")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form-group",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("メールアドレス")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail",
      "placeholder": "メールアドレス",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block mb-5",
    class: _vm.submitStyle,
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_vm._v("パスワード再発行")]), _vm._v(" "), (_vm.message) ? _c('p', [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-secondary btn-block mb-5",
    attrs: {
      "to": "/login",
      "title": ""
    }
  }, [_vm._v("ログイン画面へ戻る")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-info"
  }, [_vm._v("入力頂いたメールアドレス宛に、新しい仮パスワードをお送りいたします。"), _c('br'), _vm._v(" メールアドレスを間違えている場合など、メールが届かない場合があります。メールが届かない場合は、システムに登録しているメールアドレスをご確認の上、再度入力して下さい。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b186c61!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/Password.vue
// module id = 345
// module chunks = 1